var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseChoice',{attrs:{"title":"関連付けるクラスを選択してください","resourceType":"class","fields":_vm.fields,"items":_vm.tamai_class.tamaiClasses,"totalItems":_vm.totalTamaiClasses,"isFetching":_vm.isFetching}})}
var staticRenderFns = []

export { render, staticRenderFns }